export const COMPONENT_NAME = "shared-button-icon";
